import React,{ Component } from 'react';
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class Featuredblock extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  Height:(window.innerHeight-document.getElementsByClassName("site-header")[0].offsetHeight),
		  Width:window.innerWidth
		}
	}
	componentDidMount(){
		window.addEventListener("resize", this.updateHeight.bind(this));
	}
	updateHeight(){
		
		if(window.innerWidth!==this.state.Width){
			this.setState({
				Height: (window.innerHeight-document.getElementsByClassName("site-header")[0].offsetHeight),
				Width:window.innerWidth
			});
		}
	}
	render(){
		const { featured_home_name,
				featured_home_id='',
				featured_home_start_date,
				featured_home_image,
				featured_home_end_date,
				featured_home_slug='',
				featured_home_show_date,
				featured_home_show_text,
				featured_home_type:type,
				featured_home_time:time,
				featured_home_text:excerpt,
				clock
			} = this.props;
	
		let {image:imgUrl,title,alt,image_tiny} = featured_home_image;
		let divStyle = {
				height: (this.props.height) ? this.state.Height : ''
			}
		let imgStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'cover'
			}
		let articleText,articleDate,link;
		if(type==='ausstellungen' || type==='')
			link = "root.programm.ausstellungendetails";
		else if(type==='news')
			link = "root.informationen.newsdetails";
		else
			link = "root.programm.kalenderdetails";
		if(featured_home_show_text==='1'){
			articleText  = <span className="event-title" dangerouslySetInnerHTML={createMarkup(featured_home_name+"&nbsp;")}></span>
		}
		if(featured_home_show_date==='1')
			articleDate = <span>
						<span className="event-start">{featured_home_start_date}</span>
						{
						(featured_home_end_date)?
						<span className="event-end">-{featured_home_end_date}</span>
						:null
						}
						{(time)? <span className="event-end"> - {time} {clock}</span> : null}
					</span>		
		return(
			<UISref to={link} params={{item:featured_home_slug}}>
				<a className="fixed-ht-img featured-block" style={divStyle}>
					<div title={title} className="img-wrapper" style={imgStyle}>
					{
						(featured_home_id!=="")?
							<div>
							{
								(featured_home_id.type==='html5')?
									<video autoPlay loop muted style={{width:'100%',height:'100%',objectFit:'cover'}}>
										<source src={featured_home_id.url} type="video/mp4"/>
									</video>
								:
									<iframe width="100%" height="100%" src={featured_home_id.url+"?autoplay=1&controls=0&loop=1&playsinline=1&showinfo=0&mute=1"}></iframe>
							}		
							</div>
						:	
							null
					}
					</div>
					{(type==='news')?
						<div className="article-info txt-bold newsfeatured">
							{articleText}
							<span className="excerpt" dangerouslySetInnerHTML={createMarkup(excerpt)}></span>
						</div>
						:
						<div className="article-info txt-bold">
							{articleText}
							{articleDate} 
						</div>
					}	
				</a>	
			</UISref>
		)
	}
}
export default Featuredblock;




// WEBPACK FOOTER //
// ./src/components/Featuredblock.js